type Opts = {
  path: string
}

export default function redirect(opts: Opts) {
  if (process.env.IS_CLIENT) {
    window.location.assign(opts.path)
  }
}
